'use strict';

var _themeSections = require('@shopify/theme-sections');

var _accordion = require('../modules/accordion');

var _accordion2 = _interopRequireDefault(_accordion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _themeSections.register)('faqs', {
  onLoad: function onLoad() {
    new _accordion2.default(this.container); // eslint-disable-line no-new
  }
});